export const STORE_UI_PREFERENCES = 'STORE_UI_PREFERENCES';
export class StoreUIPreferences {
    constructor(uiPreferences) {
        this.uiPreferences = uiPreferences;
        this.type = STORE_UI_PREFERENCES;
    }
}
